<template>
	<div class="display">
		<div class="filter-section">
			<!-- Filtre par catégorie -->
			<div class="categorie">
				<b-form-group label="Filtrer par catégorie:" label-for="filter-category">
					<b-form-select id="filter-category" v-model="selectedCategory" @change="applyFilters">
						<option value="all">Toutes les catégories</option>
						<option v-for="categorie in categories" :key="categorie.id" :value="categorie.id">{{ categorie.label
						}}</option>
					</b-form-select>
				</b-form-group>
			</div>

			<!-- Filtre par prix -->
			<b-form-group label="Filtrer par prix:">
				<el-slider v-model="priceRangeTemp" range :min="minPrice" :max="maxPrice"
					@change="applyFilters"></el-slider>
				<el-input-number v-model="priceRangeTemp[0]" :step="10" :min="minPrice" :max="maxPrice"
					@change="applyFilters" controls-position="right" size="small" :precision="2"
					style="margin-right: 75px;"></el-input-number>
				<el-input-number v-model="priceRangeTemp[1]" :step="10" :min="minPrice" :max="maxPrice"
					@change="applyFilters" controls-position="right" size="small" :precision="2"></el-input-number>
				<div class="price-range">De {{ priceRangeTemp[0] }} € à {{ priceRangeTemp[1] }} €</div>
			</b-form-group>

			<!-- Filtre par marque -->
			<div>
				<el-select v-model="selectedMarque" multiple collapse-tags placeholder="Marques Disponibles"
					@change="applyFilters">
					<el-option v-for="marque in marques" :key="marque" :value="marque">{{ marque }}</el-option>
				</el-select>
			</div>

			<!-- Bouton pour les filtres -->
			<!-- <b-button variant="primary" @click="applyFilters">Appliquer les filtres</b-button> -->
			<el-button @click.prevent="clearFilters" style="margin-left: 10px;" type="danger" icon="el-icon-delete"
				circle></el-button>
		</div>

		<div class="product-section">

			<!-- Bouton du panier -->
			<el-badge :value="quantityTotal" :max="99" class="badge">
				<el-button class="cart-button" type="warning" icon="el-icon-goods" circle
					@click="showCartModal = true"></el-button>
			</el-badge>

			<!-- Modal du panier -->
			<b-modal v-model="showCartModal" id="modalCart" ref="modalCart" title="Votre Panier">
                <b-form-input v-model="devisReference" placeholder="Réf. devis (optionnel)" style="width: 200px; margin-left: auto; margin-bottom: auto; max-width: 200px;"></b-form-input>
				<div class="cart-items">
					<div v-for="item in cartItems" :key="item.id" class="cart-item">
                        <img :src="'/api/imgProductName/'+ item.ref+'/'+item.allImg[0]" style="width: 50px;flex: 0 0 50px;" @click="redirectToProduct(item.id)"/>
						<span style="flex: auto;padding-left: 15px;" class="maj" @click="redirectToProduct(item.id)" v-html="item.label"></span>
                        <span style="flex: 0 0 125px;">{{ formatPrice(item.price) }} €</span>
                        <el-input-number style="margin-left: 10px;flex: 0 0 125px;" v-model="item.quantity" @change="saveCart" :min="1" :max="30" size="small"></el-input-number>
                        <span style="flex: 0 0 125px;padding-left: 10px;">{{ (formatPrice(item.price)*item.quantity) }} €</span>
                        <el-button @click="supLine(item.id)" style="margin: 0px; border-radius: 50%;flex:0;" type="danger" icon="el-icon-delete" circle></el-button>
					</div>
				</div>
				<template #modal-footer="{ ok, Cancel }" class="modal-footer">
					<div class="cart-total modal-footer">
						<p>Total HT : {{ formatPrice(cartTotal) }} € | Quantité de produit : {{ quantityTotal }}</p>
						<p>Poids total : {{ cartWeightTotal.toFixed(2) }} kg</p>
					</div>
					<div class="content-footer">
						<p class="text-footer-panier">Pour la mise en service contacter <a href="mailto:commandes@ideal360.fr">commandes@ideal360.fr</a> ou par téléphone <a href="tel:+33971180606">09 71 18 06 06</a></p>
						<div class="btn-panier">
							<b-button style="margin-right: 10px;" variant="danger" @click="clearCart">Vider le
								Panier</b-button>
							<b-button variant="success" @click="validerPanier">Valider mon panier</b-button>
						</div>
					</div>
				</template>
			</b-modal>

			<!-- Recherche dans tous les champs -->
			<b-form-group class="overflow-auto">
				<b-input-group class="input-recherche" style="float:left;">
					<b-form-input v-model="filter" placeholder="Rechercher dans tous les champs..."></b-form-input>
					<b-input-group-append>
						<b-button :disabled="!filter" @click="filter = ''" size="sm">Effacer</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>

			<!-- Affichage des produits -->
			<div class="product-list">
				<div v-for="product in filteredProducts" :key="product.id" class="product-item" @click="redirectToDetails(product)">
					<div class="product-info">
						<div style="text-align: center; flex: 0 0 auto;">
							<img :src="'/api/imgProductName/'+ product.ref+'/'+product.allImg[0]" style="height: 150px;" mar />
						</div>
						<div style="flex: auto;">
							<p class="product-title maj" v-html="truncateString(product.label, 55)"></p>
						</div>
						<div style="">
							<p class="product-price">{{ formatPrice(product.price) }} € HT</p>
						</div>
						<div>
							<p v-if="product.stock_reel > 0">Stock : {{ product.stock_reel }}</p>
        					<p v-else class="stock-unavailable">Sur commande</p>
						</div>
						<div class="product-action">
							<h6>Quantité :</h6>
							<div class="quantity-select-wrapper" @click.stop>
								<el-input-number v-model="product.quantity" controls-position="right" controls="false"
									:min="1" :max="30"></el-input-number>
								<b-button class="add-cart" variant="primary" @click.stop="addToCart(product, product.quantity)">Ajouter au panier</b-button>
							</div>
						</div>
					</div>
				</div>

			</div>

			<!-- Affichage des modals -->
			<div class="modal">
				<b-modal id="details-modal" v-model="showModal">
					<template #modal-title="{title}" class="">
							<h4 class="maj" v-html="selectedProduct.label"></h4>
						</template>
					<div v-if="selectedProduct">
						<div v-if="selectedProduct.allImg.length > 1" style="width:90%; margin: auto;">
							<slick ref="slickTop" :options="slickOptionsTop" @beforeChange="onBeforeChangeTop">
								<div v-for="item in selectedProduct.allImg" :key="item">
									<img :src="'/api/imgProductName/'+ selectedProduct.ref+'/'+item" style="width: 60%;margin: auto;" mar @click="openZoom" />
								</div>
							</slick>
							<slick ref="slickBottom" :options="slickOptionsBottom" @beforeChange="onBeforeChangeBottom">
								<div v-for="item in selectedProduct.allImg" :key="item">
									<img :src="'/api/imgProductName/'+ selectedProduct.ref+'/'+item" style="width: 60%;margin: auto;" mar />
								</div>
							</slick>
						</div>
						<div v-else style="text-align:center;">
							<img :src="'/api/imgProductName/'+ selectedProduct.ref+'/'+selectedProduct.allImg[0]" style="width: 20rem;" mar @click="openZoom"/>
						</div>
						<p>Prix : {{ formatPrice(selectedProduct.price) }} € HT</p>
						<p v-html="selectedProduct.description"></p>
						<p>Garantie : {{ selectedProduct.array_options.options_garantie }} mois</p>
						<p v-if="selectedProduct.stock_reel > 0">Stock : {{ selectedProduct.stock_reel }}</p>
        				<p v-else class="stock-unavailable">Sur commande</p>
						<div class="product-action">
							<div class="quantity-select-wrapper" @click.stop>
								<label for="product-quantity">Quantité :</label>
								<el-input-number v-model="selectedProductQuantity" controls-position="right"
									controls="false" :min="1" :max="30"></el-input-number>
								<b-button class="add-cart" variant="primary"
									@click.stop="addToCart(selectedProduct, selectedProductQuantity)"
									style="">Ajouter au panier</b-button>
							</div>
						</div>
						<!-- Section de suggestions de produits -->
						<div v-if="productSuggestions.length">
						    <h3>Vous pourriez aussi aimer</h3>
						    <div class="suggestions">
						        <div v-for="suggestion in productSuggestions" :key="suggestion.id" class="suggestion-item">
									<img :src="'/api/imgProductName/'+ suggestion.ref+'/'+suggestion.allImg[0]" style="height: 90px;" mar />
						            <div class="suggestion-info">
						                <p class="suggestion-name">{{ suggestion.label }}</p>
						                <p class="suggestion-price">{{ formatPrice(suggestion.price) }} €</p>
						                <b-button class="suggestion-bouton" @click="openModal(suggestion)">Voir produit</b-button>
						            </div>
						        </div>
						    </div>
						</div>
					</div>
					<template #modal-footer="{}" class="details-footer">
						<div class="fiche-pdf">
							<div v-if="selectedProduct.pdfTech">
								<a v-bind:href="'/api/downloadDocPdf/'+selectedProduct.ref+'/'+selectedProduct.pdfTech">
									<span style="color: red;cursor: pointer;font-size: 25px;padding: 0 0.5em 0 0;" class='far fa-file-pdf' v-b-tooltip.hover title='Télécharger'></span>
									<span style="cursor:pointer; color:black;" v-b-tooltip.hover title='Télécharger'>Fiche Technique</span>
								</a>
							</div>
							<div v-if="selectedProduct.pdfUser">
								<a v-bind:href="'/api/downloadDocPdf/'+selectedProduct.ref+'/'+selectedProduct.pdfUser">
									<span style="color: red;cursor: pointer;font-size: 25px;padding: 0 0.5em 0 0;" class='far fa-file-pdf' v-b-tooltip.hover title='Télécharger'></span>
									<span style="cursor:pointer; color:black;" v-b-tooltip.hover title='Télécharger'>Fiche Utilisateur</span>
								</a>
							</div>
						</div>
						<div class="close-details">

						</div>
					</template>
				</b-modal>

				<b-modal ref="modalZoomImg" @hide="closeZoomImgModal" title="" id="modalZoomImg">
					<div v-if="selectedProduct">
						<div v-if="selectedProduct.allImg.length > 1" style="width:90%; margin: auto;">
							<slick ref="slickTopZoom" :options="slickOptionsTop" @beforeChange="onBeforeChangeTopZoom">
								<div v-for="item in selectedProduct.allImg" :key="item">
									<img :src="'/api/imgProductName/'+ selectedProduct.ref+'/'+item" style="width: 73%;margin: auto;" mar />
								</div>
							</slick>
							<slick ref="slickBottomZoom" :options="slickOptionsBottom" @beforeChange="onBeforeChangeBottomZoom">
								<div v-for="item in selectedProduct.allImg" :key="item">
									<img :src="'/api/imgProductName/'+ selectedProduct.ref+'/'+item" style="width: 73%;margin: auto;" mar />
								</div>
							</slick>
						</div>
						<div v-else style="text-align:center;">
							<img :src="'/api/imgProductName/'+ selectedProduct.ref+'/'+selectedProduct.allImg[0]" style="width: 75%;" mar />
						</div>
					</div>
					<template #modal-footer="{}" class="details-footer">
						<div></div>
					</template>
				</b-modal>
			</div>
			<el-button @click="loadMoreProducts" type="primary">Charger plus de produits</el-button>
		</div>
	</div>
</template>

<script>
//import conf from '../../../config/api.js';
import axios from 'axios';
import script_e_commerce from '../../../script/script_e_commerce.js';
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ElSlider } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
var moment = require('moment');
var htmlDecode = require('js-htmlencode').htmlDecode;

export default {
	data() {
		return {
			products: [],
			filter: '',
			priceRangeTemp: [0, 100000],
			minPrice: 0,
			maxPrice: 1000,
			categories: [],
			selectedCategory: 'all',
			maxLength: 120,
			showModal: false,
			marques: [],
			selectedMarque: [],
			showCartModal: false,
			cartItems: [],
			selectedProductQuantity: 1,
			quantity: 1,
			loadedProductsCount: 20,
			productsToLoad: 20,
			productSuggestions: [],
			devisReference: '',
			imgProduct:{},
			slickOptionsBottom: {
                slidesToShow: 3,
				dots: true,
				slidesToScroll: 1,
				centerMode: true,
				arrows: false,
				asNavFor: this.$refs.slickTop,
				focusOnSelect: true
                // Any other options that can be got from plugin documentation
            },
			slickOptionsTop: {
                slidesToShow: 1,
				arrows: false,
				slidesToScroll: 1,
				asNavFor: this.$refs.slickBottom,
				fade: true,
                // Any other options that can be got from plugin documentation
            },
			fullscreenLoading: false
		};
	},

	computed: {

		cartTotal() {
			return this.cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
		},
		quantityTotal() {
			return this.cartItems.reduce((total, item) => total + item.quantity, 0);
		},
		filteredProducts() {
			let products = this.products;


			if (!this.filter) {
				return products.slice(0, this.loadedProductsCount);
			}
			const lowerCaseFilter = this.filter.toLowerCase();
			return this.products.filter(product => product.label.toLowerCase().includes(lowerCaseFilter)); //products.slice(0, this.loadedProductsCount);
		},

		cartWeightTotal() {
    	    return this.cartItems.reduce((totalWeight, item) => {
    	        return (totalWeight + (item.weight * item.quantity))/1000;
    	    }, 0);
    	},

	},
	components: {
		Slick
	},
	methods: {
		next() {
            this.$refs.slickTop.next();
            this.$refs.slickBottom.next();
        },

        prev() {
            this.$refs.slickTop.prev();
            this.$refs.slickBottom.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slickTop.reSlick();
                this.$refs.slickBottom.reSlick();
            });
        },
		refreshSlider() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slickTop.reSlick();
                this.$refs.slickBottom.reSlick();
            });
        },
		onBeforeChangeTop(event, slick, currentSlide, nextSlide) {
			this.$refs.slickBottom.goTo(nextSlide)
			// this.$refs.slickBottom.goTo(nextPosition)
		},
		onBeforeChangeBottom(event, slick, currentSlide, nextSlide) {
			console.log(this.$refs.slickTop)
			this.$refs.slickTop.goTo(nextSlide)
			// this.$refs.slickTop.goTo(nextPosition)
		},
		onBeforeChangeTopZoom(event, slick, currentSlide, nextSlide) {
			this.$refs.slickBottomZoom.goTo(nextSlide)
			// this.$refs.slickBottom.goTo(nextPosition)
		},
		onBeforeChangeBottomZoom(event, slick, currentSlide, nextSlide) {
			this.$refs.slickTopZoom.goTo(nextSlide)
			// this.$refs.slickTop.goTo(nextPosition)
		},
		openZoom(){
			this.$refs.modalZoomImg.show()
		},
		closeZoomImgModal(){
			this.$refs.modalZoomImg.hide()
		},
		async applyFilters() {

			// Filtre par catégorie
			await this.getProductsByCategory();

			// Filtre par marque
			if (this.selectedMarque.length > 0) {
				this.products = this.products.filter(product => {
					// Assurez-vous que la propriété 'marque' correspond à celle des produits renvoyés par l'API
					return this.selectedMarque.includes(product.array_options.options_marque);
				});
			}

			// Filtre par gamme de prix
			this.products = this.products.filter(product => {
				return product.price >= this.priceRangeTemp[0] && product.price <= this.priceRangeTemp[1];
			});

		},


		async clearFilters() {
			this.selectedCategory = 'all';
			this.selectedMarque = [];
			this.priceRangeTemp = [this.minPrice, this.maxPrice];

			this.applyFilters();
		},

		formatPrice(value) {
			const numericValue = parseFloat(value);

			if (!isNaN(numericValue)) {
				return numericValue.toFixed(2);
			} else {
				return '0.00';
			}
		},

		truncateString(str, maxLength) {
			if (typeof str === 'string' && str.length > maxLength) {
				return str.substring(0, maxLength) + '...';
			}
			return str;
		},

		async openModal(product) {
			this.selectedProduct = product;
			this.showModal = true;
			this.selectedProductQuantity = 1;
			await this.loadProductSuggestions(product);
			// if(product.allImg.length>1){
			// 	this.$refs.slickTop.reSlick();
            //     this.$refs.slickBottom.reSlick();
			// }
		},

		getCategories: script_e_commerce.getCategories,

		getProductsByCategory: script_e_commerce.getProductsByCategory,

		getProductMarques: script_e_commerce.getProductMarques,

		toasterErrorTopRight: script_e_commerce.toasterErrorTopRight,

		toasterSuccessTopRight: script_e_commerce.toasterSuccessTopRight,
		visualDocPdf: script_e_commerce.visualDocPdf,
		
		async validerPanier(){
			const loading = this.$loading({
				lock: true,
				text: 'Chargement',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
			if(await this.validerPanierEtGenererDevis()){
				loading.close()
			}
		},

		validerPanierEtGenererDevis: script_e_commerce.validerPanierEtGenererDevis,

		getImgProduct: script_e_commerce.getImgProduct,

		async updatePriceRange() {
			if (this.products.length > 0) {
				this.minPrice = Math.min(...this.products.map(product => product.price));
				this.maxPrice = Math.max(...this.products.map(product => product.price));

				this.priceRangeTemp = [this.minPrice, this.maxPrice];
			}
		},

		async clearCart() {
			this.cartItems = [];
			localStorage.removeItem('cart');
		},


		async addToCart(product, quantity) {
			const existingProductIndex = this.cartItems.findIndex(item => item.id === product.id);

			if (existingProductIndex !== -1) {
				this.$set(this.cartItems[existingProductIndex], 'quantity', this.cartItems[existingProductIndex].quantity + quantity);
			} else {
				const newProduct = { ...product, quantity };
				this.cartItems.push(newProduct);
			}

			this.saveCart();

			product.quantity = 1;

			this.toasterSuccessTopRight('Produit ajouté au panier !');
		},


		async saveCart() {
			localStorage.setItem('cart', JSON.stringify(this.cartItems));
		},

		async loadCart() {
			const cart = localStorage.getItem('cart');
			if (cart) {
				this.cartItems = JSON.parse(cart);
			}
		},

		async supLine(itemId) {
			this.cartItems = this.cartItems.filter(item => item.id !== itemId);
			this.saveCart();
		},

		async loadMoreProducts() {
			this.loadedProductsCount += this.productsToLoad;
		},

		shuffleArray(array) {
	        for (let i = array.length - 1; i > 0; i--) {
	            const j = Math.floor(Math.random() * (i + 1));
	            [array[i], array[j]] = [array[j], array[i]];
	        }
	        return array;
	    },

	    async loadProductSuggestions(product) {
	        let filteredProducts = this.products.filter(p =>
	            p.category === product.category && p.id !== product.id
	        );

	        this.shuffleArray(filteredProducts);

	        this.productSuggestions = filteredProducts.slice(0, 4);
	    },

		redirectToDetails(product){
			this.$router.push('../product/'+product.id+"/details")
		},
		redirectToProduct(id){
			this.$router.push({ name: 'details-product', params: { pid: id} })
		}

		/*uppercaseText(text) {
		  if (!text) return '';

		  // Remplacements basiques pour les entités HTML courantes
		  const replacements = {
			'&lt;': '<',
			'&gt;': '>',
			'&amp;': '&',
			'&quot;': '"',
			'&apos;': "'"
		  };
	  
		  // Fonction de remplacement pour les entités HTML
		  function replaceEntity(match) {
			return replacements[match] || match;
		  }
	  
		  // Remplacer les entités HTML par les caractères correspondants
		  let decodedText = text.replace(/&lt;|&gt;|&amp;|&quot;|&apos;/g, replaceEntity);
	  
		  // Convertir le texte en majuscules
		  return decodedText.toUpperCase();
		},

		generateHtml(item) {
			return `<p>${this.uppercaseText(item.label)} - ${item.quantity} x ${this.formatPrice(item.price)} €</p>`;
			},*/

	},


	async created() {
		this.loadCart();
	},

	async mounted() {
		await this.getCategories();
		await this.getProductsByCategory();
		await this.getProductMarques();
		await this.updatePriceRange();
	}

}
</script>
<style scoped>
.cart-items{
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.cart-item{
    border: black solid 1px;
    padding: 10px;
    margin: 10px;
    display: flex;
    align-content: center;
    justify-content: space-around;
    align-items: center;
    flex: 1 1 100%;
    width: 100%;
}
</style>
<style>
.display {
	display: flex;
	flex-wrap: nowrap;
}

.filter-section {
	width: 15%;
	padding: 10px;
	border-right: 1px solid #ddd;
	box-sizing: border-box;
}

.product-section {
	width: 80%;
	padding: 15px;
	margin: 15px;
	box-sizing: border-box;
}

.product-list {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
}

.product-item {
	width: calc(25% - 20px);
	margin: 10px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	background-color: #fff;
	padding: 10px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

.product-info {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
    align-items: center;
}

.product-action {
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	width: 100%;
	gap: 10px;
	bottom: 10px;
	left: 10px;
}

.quantity-select {
	flex-grow: 1;
}

.quantity-select-wrapper {
	display: flex;
	flex-direction: row;
    align-items: stretch;
}

.quantity-select-wrapper label {
	margin-bottom: 5px;
	font-weight: bold;
}

.add-cart1 {
	position: absolute;
	bottom: 10px;
	left: 10px;
	margin: 0;
}

.product-image {
	width: 100%;
	max-width: 100px;
	height: auto;
	border-radius: 5px;
	margin-right: 10px;
}

.product-description {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
}

.product-title {
	font-size: 18px;
	font-weight: bold;
	color: #333;
	text-align: center;
}

.product-price {
	font-size: 16px;
	color: #666;
	text-align: center;
	bottom: 100px;
}

.modal .modal-dialog {
	margin: 30px auto;
}

.modal-body {
	max-height: 650px;
	overflow-y: auto;
}

.b-form-group {
	margin-bottom: 20px;
}

.b-form-select,
.b-form-input,
.b-form-range {
	width: 100%;
}

.b-button,
.el-button {
	margin-top: 10px;
	border-radius: 2px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
	.display {
		flex-direction: column;
	}

	.filter-section,
	.product-section {
		width: 100%;
	}

	.product-item {
		width: calc(50% - 20px);
	}
}

.cart-button {
	position: fixed;
	transform: scale(1.5);
	right: 50px;
	bottom: 30px;
	transform-origin: bottom right;
	z-index: 100;
}

.badge {
	position: fixed;
	bottom: 75px;
	right: 50px;
	z-index: 1000;
}

.content-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.text-footer-panier {
	margin-left: 10px;
	margin-top: -50px;
	text-align: left;
	font-weight: bold;
}

.btn-panier {
	display: flex;
	justify-content: flex-end;

}

.cart-total {
	border-top: 0px;
	border: 1px solid #dee2e6;
	margin-bottom: 10px;
}

.price-range {
	margin-top: 5px;
	text-align: center;
}

.maj {
	text-transform: uppercase;
}

.suggestions {

}

.suggestion-item {
    flex-basis: 21%;
    margin: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    background-color: #fff;
    padding: 10px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.suggestion-image {
    width: 80%;
    max-height: 150px;
    object-fit: cover;
    border-radius: 4px;
    margin-bottom: 8px;
}

.suggestion-info {
    text-align: center;
    margin-bottom: 15px;
}

.suggestion-name {
    font-size: 16px;
    color: #333;
    margin-bottom: 4px;
}

.suggestion-price {
    font-size: 14px;
    color: #888;
}

.suggestion-bouton {
    position: absolute;
    bottom: 15px;
    left: 10px;
    right: 10px;
}

.details-footer{

}

.fiche-pdf{
	width: 100%;
}

.close-details{
	
}

#modalZoomImg .modal-dialog{
	height: 90%;
}

#modalZoomImg .modal-content{
	height: 100%;
}

#modalZoomImg .modal-body{
	max-height: 700px;
}

#details-modal .modal-dialog{
	height: 90%;
}

#details-modal .modal-content{
	height: 100%;
}
</style>